import React from "react";
import "./App.css";
import Hero from "./components/Hero";
import BigStatement from "./components/BigStatement";
import ThreePanelCapability from "./components/ThreePanelCapability";
import WhatWeDo from "./components/WhatWeDo";
import ScrollExplanation from "./components/ScrollExplanation";
import HowWeWork from "./components/HowWeWork";
import WhoWeWorkWith from "./components/WhoWeWorkWith";
import ExperienceCredibility from "./components/ExperienceCredibility";
import HowEngagementsStart from "./components/HowEngagementsStart";
import ClosingStatement from "./components/ClosingStatement";

function App() {
  return (
    <div className="App">
      <Hero />
      <BigStatement />
      <ThreePanelCapability />
      <WhatWeDo />
      <ScrollExplanation />
      <HowWeWork />
      <WhoWeWorkWith />
      <ExperienceCredibility />
      <HowEngagementsStart />
      <ClosingStatement />
    </div>
  );
}

export default App;